const TOKEN_KEY = 'access_token'
const REFRESH_TOKEN_KEY = 'refresh_token'
const ACCESS_KEY = 'client_access_key'
const CLIENT_CODE = 'client_code'
const LOGIN_TYPE = 'login_type'
const USERNAME = 'username'
const AGENCYVIEW = 'agencyView'
const BRANDVIEW = 'brandView'
const DISTRIBUTORVIEW = 'distributorView'
const ITEMLISTVIEW = 'itemListView'
const USER_PROFILE = 'dashboard_user_profile'

/**
 * Manage the how Access Tokens are being stored and retreived from storage.
 *
 * Current implementation stores to localStorage. Local Storage should always be
 * accessed through this instance.
 **/

const TokenService = {

  hasSeenLoginPage () {
    const storedData = localStorage.getItem('hasSeenLoginPage')
    if (!storedData) {
      return false
    }
    try {
      const data = JSON.parse(storedData)
      const now = new Date().getTime()

      return data.expiresAt > now && data.hasSeenLoginPage === true
    } catch (e) {
      localStorage.removeItem('hasSeenLoginPage')
      return false
    }
  },

  setSeenLoginPage () {
    const expiresAt = new Date()
    expiresAt.setDate(expiresAt.getDate() + 14)

    const data = {
      hasSeenLoginPage: true,
      expiresAt: expiresAt.getTime()
    }

    localStorage.setItem('hasSeenLoginPage', JSON.stringify(data))
  },

  removeSeenLoginPage () {
    localStorage.removeItem('hasSeenLoginPage')
  },

  getAgencyView () {
    return localStorage.getItem('agencyView')
  },

  saveAgencyView (agencyView) {
    localStorage.setItem(AGENCYVIEW, agencyView)
  },

  removeAgencyView () {
    localStorage.removeItem(AGENCYVIEW)
  },

  getBrandView () {
    return localStorage.getItem('brandView')
  },

  saveBrandView (brandView) {
    localStorage.setItem(BRANDVIEW, brandView)
  },

  removeBrandView () {
    localStorage.removeItem(BRANDVIEW)
  },

  // Read the distributor filter enablement flag for the current client
  getDistributorView () {
    return localStorage.getItem(DISTRIBUTORVIEW)
  },

  // Persist distributor filter enablement flag
  saveDistributorView (distributorView) {
    localStorage.setItem(DISTRIBUTORVIEW, distributorView)
  },

  // Remove distributor filter flag
  removeDistributorView () {
    localStorage.removeItem(DISTRIBUTORVIEW)
  },

  getItemListView () {
    return localStorage.getItem(ITEMLISTVIEW)
  },

  saveItemListView (itemListView) {
    localStorage.setItem(ITEMLISTVIEW, itemListView)
  },

  removeItemListView () {
    localStorage.removeItem(ITEMLISTVIEW)
  },

  getUsername () {
    return localStorage.getItem(USERNAME)
  },

  saveUsername (username) {
    localStorage.setItem(USERNAME, username)
  },

  removeUsername () {
    localStorage.removeItem(USERNAME)
  },

  getUserProfile () {
    const profile = localStorage.getItem(USER_PROFILE)
    if (!profile) return null

    try {
      return JSON.parse(profile)
    } catch (error) {
      localStorage.removeItem(USER_PROFILE)
      return null
    }
  },

  saveUserProfile (profile) {
    if (!profile) {
      this.removeUserProfile()
      return
    }
    localStorage.setItem(USER_PROFILE, JSON.stringify(profile))
  },

  removeUserProfile () {
    localStorage.removeItem(USER_PROFILE)
  },

  getToken () {
    return localStorage.getItem(TOKEN_KEY)
  },

  saveToken (accessToken) {
    localStorage.setItem(TOKEN_KEY, accessToken)
  },

  getAccessKey () {
    return localStorage.getItem(ACCESS_KEY)
  },

  getLoginCode () {
    return localStorage.getItem(CLIENT_CODE)
  },

  getLoginType () {
    return localStorage.getItem(LOGIN_TYPE)
  },

  saveAccessKey (key) {
    localStorage.setItem(ACCESS_KEY, key)
  },

  saveLoginCode (clientCode) {
    localStorage.setItem(CLIENT_CODE, clientCode)
  },

  saveLoginType (loginType) {
    localStorage.setItem(LOGIN_TYPE, loginType)
  },

  removeAccessKey () {
    localStorage.removeItem(ACCESS_KEY)
  },

  removeToken () {
    localStorage.removeItem(TOKEN_KEY)
  },

  removeLoginCode () {
    localStorage.removeItem(CLIENT_CODE)
  },

  removeLoginType () {
    localStorage.removeItem(LOGIN_TYPE)
  },

  getRefreshToken () {
    return localStorage.getItem(REFRESH_TOKEN_KEY)
  },

  saveRefreshToken (refreshToken) {
    localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken)
  },

  removeRefreshToken () {
    localStorage.removeItem(REFRESH_TOKEN_KEY)
  },

  clearLogin (options) {
    const preserveSetupUsername = options && options.preserveSetupUsername
    this.removeToken()
    this.removeRefreshToken()
    this.removeAccessKey()
    this.removeLoginCode()
    this.removeLoginType()
    this.removeUsername()
    this.removeUserProfile()
    this.removeAgencyView()
    this.removeBrandView()
    this.removeDistributorView()
    this.removeItemListView()
    this.removeSeenLoginPage()
    if (!preserveSetupUsername) {
      window.sessionStorage.removeItem('tastingiq_login_username')
    }
  },

  clearOneTimeSetup () {
    window.sessionStorage.removeItem('tastingiq_one_time_invitation')
    window.sessionStorage.removeItem('tastingiq_one_time_login_handoff')
  }

}

export { TokenService }
